import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';

function ActivityWidgetComponent({
  componentRef,
  destination,
  partnerId,
  hrefUrl,
  language,
  tld,
  additionalQueryParam,
}) {
  return (
    <Root>
      <Title>
        <FormattedMessage
          id={'activityWidget.header.withDestination'}
          description={'Things to do in {destination}'}
          defaultMessage={'Things to do in {destination}'}
          values={{ destination }}
        />
      </Title>
      <div
        style={{ maxWidth: '1400px', margin: '0 auto' }}
        data-gyg-href={hrefUrl}
        data-gyg-locale-code={language}
        data-gyg-widget='activities'
        data-gyg-number-of-items='4'
        data-gyg-partner-id={partnerId}
        data-gyg-q={destination}
      ></div>
      <AcnhorContainer>
        <Anchor
          href={`https://getyourguide.${tld}/s/?q=${destination}&partner_id=${partnerId}`}
          target='_blank'
          rel='noopener noreferrer'
        >
          <FormattedMessage
            id={'activityWidget.label.findMoreActivities'}
            description={'Find more activities in {destination}'}
            defaultMessage={'Find more activities in {destination}'}
            values={{ destination }}
          />
        </Anchor>
      </AcnhorContainer>
    </Root>
  );
}

export default ActivityWidgetComponent;

const Root = styled.div``;

const Title = styled.h2`
  margin: 0 0 32px;
  font-family: ${({ theme }) => theme.fonts.displaySubtle};
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.default};
`;

const AcnhorContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

const Anchor = styled.a`
  font-size: 1.8em;
  font-weight: bold;
`;
